import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";

const KEY = "moringa-alloc-hide-mm";
const EVT = "moringa-hide-mm";

// Shared "hide Money Market from allocation" preference (Dashboard + Performance), kept per device
export function useHideMoneyMarket() {
    const read = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };
    const [on, setOn] = useState(read);
    useEffect(() => {
        const sync = () => setOn(read());
        window.addEventListener(EVT, sync);
        return () => window.removeEventListener(EVT, sync);
    }, []);
    const set = (v) => {
        try { localStorage.setItem(KEY, v ? "1" : "0"); } catch { /* storage unavailable */ }
        setOn(v);
        window.dispatchEvent(new Event(EVT));
    };
    return [on, set];
}

export function HideMMSwitch({ checked, onChange, testId }) {
    return (
        <label className="flex items-center gap-1.5 text-xs text-muted-foreground cursor-pointer">
            <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />Hide Money Market
        </label>
    );
}
